<template>
    <searchContainer :searchHandler="search" :resetHandler="reset">
        <template v-slot:items>
            <div class="row">
                <input-text v-model="filters.backend_id" :options="{ id: 'backend_id', transPrefix: `${transPrefix}.fields`, label: 'backend_id' }"/>
                <input-number v-model="filters.id" :options="{ id: 'id', step: 1, transPrefix: `${transPrefix}.fields`, label: 'id' }"/>
                <input-number v-model="filters.captain_id" :options="{ id: 'captain_id', step: 1, transPrefix: `${transPrefix}.fields`, label: 'captain' }"/>
                <select-platforms v-model="filters.platform_id" :options="{ id: 'platform_id', label: 'platform', placeholder: 'placeholders.all'}"/>
                <select-platform-brands v-model="filters.brand_id" :platform_id="filters.platform_id" :options="{ id: 'brand_id', label: 'brands', disabled: !filters.platform_id, multiple: true, placeholder: 'placeholders.all' }"/>
                <select-payment-types v-model="filters.payment_type" :options="{ id: 'payment_type', transPrefix: `${transPrefix}.fields`, label: 'payment_type', placeholder: 'placeholders.all' }"/>
                <select-order-types v-model="filters.type" :options="{ id: 'type', label: 'type', placeholder: 'placeholders.all' }"/>
                <select-order-status v-model="filters.order_status" :options="{ id: 'order_status', label: 'status', placeholder: 'placeholders.all', multiple: true }"/>
                <select-order-assignment-methods v-model="filters.assignment_method" :options="{ id: 'assignment_method', label: 'assignment_method', transPrefix: `${transPrefix}.fields`, multiple: true, placeholder: 'placeholders.all' }"/>
                <select-suppliers v-model="filters.supplier_id" :options="{ id: 'supplier_id', label: 'supplier', placeholder: 'placeholders.all' }"/>
                <select-countries v-model="filters.country_id" :options="{ id: '', label: 'country', action: countries_list_action, placeholder: 'placeholders.all', disabled: canNotSelectCountry() }"/>
                <select-cities v-model="filters.city_id" :country_id="filters.country_id" :options="{ id: 'city_id', label: 'city', action: cities_list_action, placeholder: 'placeholders.all', disabled: canNotSelectCity() }"/>
                <select-order-timeline-status v-model="filters.order_timeline_status" :options="{ id: 'order_timeline_status', label: 'timeline_status', transPrefix: `${transPrefix}.fields`, placeholder: 'placeholders.all' }"/>
                <select-order-gift-status v-model="filters.order_gift_status" :options="{ id: 'order_gift_status', label: 'gift_status', transPrefix: `${transPrefix}.fields`, placeholder: 'placeholders.all' }"/>
            </div>
            <div class="row">
                <input-date v-model="filters.created_from" :options="{ id: 'created_from', label: 'created_from' }"/>
                <input-date v-model="filters.created_to" :options="{ id: 'created_to', label: 'created_to' }"/>
            </div>
        </template>
    </searchContainer>
</template>
<script>

    import {mapGetters} from "vuex";
    import {CRUD_SEARCH_RESET} from "actions/crud";
    import searchContainer from "@/components/crud/card/CardSearch";
    import {COUNTRIES_PUBLIC_LIST} from 'actions/countries';
    import {CITIES_PUBLIC_LIST} from 'actions/cities';

    const CRUD_CODE = "orders";
    export default {
        name: "OrderSearch",
        components: {
            searchContainer
        },
        props: {
            listHandler: {
                type: Function,
                default: () => {
                }
            },
        },
        data() {
            return {
                transPrefix: CRUD_CODE,
                filters: {
                    backend_id: this.getFilterByKey('backend_id'),
                    captain_id: this.getFilterByKey('captain_id'),
                    platform_id: this.getFilterByKey('platform_id'),
                    brand_id: this.getFilterByKey('brand_id'),
                    payment_type: this.getFilterByKey('payment_type'),
                    order_status: this.getFilterByKey('order_status'),
                    order_timeline_status: this.getFilterByKey('order_timeline_status'),
                    order_gift_status: this.getFilterByKey('order_gift_status'),
                    assignment_method: this.getFilterByKey('assignment_method'),
                    supplier_id: this.getFilterByKey('supplier_id'),
                    country_id: this.getFilterByKey('country_id'),
                    city_id: this.getFilterByKey('city_id'),
                    created_from: this.getFilterByKey('created_from'),
                    created_to: this.getFilterByKey('created_to'),
                },
                filtersMap: {
                    backend_id: 'backendId',
                    captain_id: 'captainId',
                    supplier_id: 'supplierId',
                    country_id: 'countryId',
                    city_id: 'cityId',
                    platform_id: 'platformId',
                    brand_id: 'brandId',
                    payment_type: 'paymentType',
                    order_status: 'orderStatus',
                    order_timeline_status: 'timelineStatus',
                    order_gift_status: 'giftStatus',
                    assignment_method: 'assignmentMethod',
                    created_from: 'startDate',
                    created_to: 'endDate',
                },
                countries_list_action: COUNTRIES_PUBLIC_LIST,
                cities_list_action: CITIES_PUBLIC_LIST,
            }
        },
        mounted() {
            this.setSearchParams(this.filters, this.filtersMap);
        },
        computed: {
            ...mapGetters([
                "getSearchFilters"
            ])
        },
        methods: {
            search() {
                this.resetPagination();
                this.setSearchParams(this.filters, this.filtersMap, {routeParams: this.getFilters(this.filters)});
                this.pushRoute(this.getSearchFilters);
                this.listHandler();
            },
            reset() {
                this.resetPagination();
                this.$store.dispatch(CRUD_SEARCH_RESET);
                this.filters = this.clearFilters(this.filters);
                this.pushRoute();
                this.listHandler();
            },
            resetPagination() {
                //Reset Pagination
                this.$emit('input', 0);
            },
            pushRoute(query = {}) {
                this.$router.push({name: this.$route.name, query}).catch(() => {});
            },
            canSelectCountry() {
                return true;
            },
            canNotSelectCountry() {
                return !this.canSelectCountry();
            },
            canSelectCity() {
                return this.filters.country_id;
            },
            canNotSelectCity() {
                return !this.canSelectCity();
            },
        }
    };
</script>
